<template>
    <div class="row">
        <div class="col-md-4 col-md-push-8 order-md-8">
            <div :class="boxClass.box">
                <div v-if="theme=='bs3' || theme=='evt'" :class="boxClass.boxHeader">Product Selection</div>
                <h5 v-else class="card-header">GiftCard Selection</h5>
                <div :class="[boxClass.boxBody, boxClass.noPadding]">
                    <quantity-picker
                        :show-button="false"
                        :entity="giftCard"
                        v-model="quantity"
                    >
                    </quantity-picker>
                </div>
            </div>
        </div>
        <div class="col-md-8 col-md-pull-4 order-md-4">
            <div v-if="user==null || !user.id">
                <div :class="boxClass.box">
                    <div :class="[boxClass.boxHeader]">
                        Step 1: Enter your email address
                    </div>
                    <div :class="[boxClass.boxBody]">
                        <login-or-signup
                            @authenticated="authenticated"
                            :theme="loginTheme"
                            :participant-user-authentication-strategy="authenticationStrategy">
                        </login-or-signup>
                    </div>
                </div>
            </div>
            <div v-if="user !=null && user.id">
                <div :class="boxClass.box">
                    <div :class="[boxClass.boxBody]">
                        <div class="form-group">
                            <input type="checkbox" id="showCreditForm" v-model="showCreditForm">
                            <label for="showCreditForm">Share this gift card NOW with a friend (leave unchecked to share
                                it at a
                                later date)</label>
                        </div>
                        <div>
                            <b-form @submit.prevent="submitForm">
                                <div v-if="showCreditForm">
                                    <div class="form-group">


                                        <label>Recipient Name:</label>
                                        <b-form-input
                                            required
                                            v-model="credit_details.name"
                                            placeholder="Name"
                                        ></b-form-input>

                                    </div>
                                    <div class="form-group">
                                        <label>Recipient Email:</label>
                                        <b-form-input
                                            type="email"
                                            required
                                            v-model="credit_details.email"
                                            placeholder="Email"
                                        ></b-form-input>

                                    </div>
                                    <div class="form-group">
                                        <label>Recipient Message:</label>
                                        <b-form-textarea
                                            id="textarea"
                                            v-model="credit_details.message"
                                            placeholder="Enter your message"
                                            rows="3"
                                            max-rows="6"
                                        ></b-form-textarea>

                                    </div>
                                </div>

                                <input v-if="quantity>0"
                                       type="submit"
                                       value="Add to basket"
                                       class="btn btn-ar btn-block btn-success"
                                />

                            </b-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import LoginOrSignup from '../../Users/LoginOrSignup/LoginOrSignup.vue'
import PlusMinusControl from '../../AAA_TO_REFACTOR/PlusMinsControl.vue'
import QuantityPicker from '../../AAA_TO_REFACTOR/QuantityPicker.vue'

export default {
    props: {
        edit: {
            type: Boolean,
            default: false
        },
        userProp: {
            type: Object,
            default: null
        },
        creditProp: {
            type: Object,
            default: () => ({})
        },
        giftCard: {
            type: Object,
            default: () => ({})
        },
        theme: {
            type: String,
            default: 'bs3'
        },
        authenticationStrategy: {
            type: String,
            default: 'guest_login'
        },
    },
    components: {
        PlusMinusControl,
        LoginOrSignup,
        QuantityPicker
    },
    filters: {},
    data() {
        return {
            user: {},
            showCreditForm: false,
            credit_details: {
                name: '',
                email: '',
                message: '',
            },
            quantity: 0

        }
    },
    computed: {
        boxClass() {
            if (this.theme == 'bs3') {
                return {
                    box: 'panel panel-default',
                    boxHeader: 'panel-heading',
                    boxBody: 'panel-body',
                    noPadding: 'no-padding'
                }

            } else if (this.theme == 'evt') {
                return {
                    box: 'box box-default',
                    boxHeader: 'box-header with-border',
                    boxBody: 'box-body',
                    noPadding: 'no-padding'
                }
            } else {
                return {
                    box: 'card card-default',
                    boxHeader: 'card-header',
                    boxBody: 'card-body',
                    noPadding: 'px-0 py-0'
                }
            }
        },
        loginTheme() {
            if (this.theme == "evt") {
                return "bs3";
            }
            return "bs4";
        }
    },
    created() {
        this.user = this.userProp;

        if (this.user !== null) {
            this.authenticated(this.user);
        }

        // if this is an edit populate the details from one of the orders provided
        if (this.edit) {

        }


    },
    methods: {
        submitForm() {
            let url = window.location.href;

            axios({
                method: 'POST',
                url: '/api/internal/credits/bulk.json',
                data: {
                    'quantity': this.quantity,
                    'gift_card_id': this.giftCard.id,
                    'credit_details': this.credit_details
                },
            }).then((response) => {
                url = window.location.origin + '/basket';
                window.location.href = url;
            }).catch(err => {
                window.location.href = url;
            })

        },
        authenticated(user) {
            this.user = user;
            this.credit_details.user_id = user.id;
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Credits/Form/Default.vue